<form [formGroup]="m2Form" *ngIf="m2Form" (ngSubmit)="onSubmit()" class="myform">
  <div class="p-5">

    <div class="flex justify-center items-baseline flex-wrap">
      <div class="flex m-2">
        <mat-form-field>
          <mat-label><span class="text-xs">Gamma (ɣ) &nbsp; value</span></mat-label>
          <input matInput formControlName="gVal" autocomplete="off">
          <mat-error *ngIf="m2Form.invalid && m2Form.touched">
            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex m-2">
        <mat-form-field>
          <mat-label><span class="text-xs">Downstream mach value (M2)</span></mat-label>
          <input matInput formControlName="m2Val" autocomplete="off">
          <mat-error *ngIf="m2Form.invalid && m2Form.touched">
            <span class="myerror">M2 must be subsonic</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="sbmtArea flex justify-center items-baseline flex-wrap">
      <button mat-raised-button type="submit" [disabled]="m2Form.invalid">Calculate</button>
    </div>


  </div>
</form>
<div fxLayoutAlign="center" *ngIf="m2Bool">
    <table>
      <tr>
        <td>
          <!-- <m1></m1> -->
          M1
        </td>
        <td>{{ nsm1() }}</td>
      </tr>
      <tr>
        <td>
          <!-- <p2p1></p2p1> -->
          p2/p1
        </td>
        <td> {{ nsp2p1() | number:'.1-5' }} </td>
      </tr>
  
      <tr>
        <td>
            t2/t1  
          <!-- <t2t1></t2t1> -->
        </td>
        <td>{{ nst2t1()  | number:'.1-5' }}</td>
  
      </tr>
  
      <tr>
        <td>
          dva1
          <!-- <dva1></dva1> -->
        </td>
        <td> {{ nsdva1() | number:'.1-5' }} </td>
      </tr>
  
      <tr>
        <td>
          pt2/pt1
          <!-- <pt2pt1> </pt2pt1> -->
        </td>
        <td>{{ nspt2_pt1() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
        <td>
          pt2/p1
          <!-- <pt2p1> </pt2p1> -->
        </td>
        <td> {{ nspt2_p1() | number:'.1-5' }} </td>
      </tr>
  
    </table>
  </div>